import React from "react";
import BMWLogo from "../../assets/images/BMWLogo.png";

const Logo = React.memo(({ carModel = "X3 30 xDrive", trimType = "classic", onBackClick }) => {
  // Determine the correct model name based on trim type
  const getModelName = () => {
    if (trimType === "msport" || carModel.toLowerCase().includes("m sport")) {
      return "X3 30 xDrive with M Sport";
    }
    return "X3 30 xDrive";
  };

  const handleLogoClick = () => {
    if (onBackClick) {
      onBackClick();
    }
  };

  return (
    <div className="flex items-center gap-3 px-2 pt-[3rem] pb-[2rem]">
      <div className="flex items-center gap-3 px-2 py-2 bg-black/40 w-full rounded-full">
        {/* BMW Logo */}
        <img
          src={BMWLogo}
          alt="BMW Logo"
          className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 object-contain cursor-pointer hover:opacity-80 transition-opacity duration-200"
          onClick={handleLogoClick}
        />

        {/* Separator */}
        <div className="w-px h-[1.2rem] bg-white"></div>

        {/* Car Model Name */}
        <h2 className="text-white text-lg sm:text-xl md:text-2xl font-bmw font-light tracking-wide" style={{ textShadow: '0 2px 0.8px rgba(0, 0, 0, 0.25), 1px 2px 4px rgba(0, 0, 0, 0.25), 0 4px 4px rgba(0, 0, 0, 0.25)' }}>
          {getModelName()}
        </h2>
      </div>
    </div>
  );
});

export default Logo;
